
import { RightOutlined } from "@ant-design/icons";
import {Row, Col, Button, Form, Input, Select, Space} from "antd";
import TextArea from "antd/lib/input/TextArea";
import React, { useEffect, useState } from "react";
import { useDispatch } from 'react-redux';

import { EDIT_MODE, SUCCESS_STATUS } from "../../../utility/Constants";

import CustomMessage from "../../common/CustomMessage";
import commonUtility from "../../../utility/Utils";
import generalCustomerService from "../../../api/general.customer.service";
import { addCustomer } from "../../../store/customerSlice";

const { Option } = Select;



const GeneralCustomerEntry = ({ data , onDrawerClose}) => {

    const dispatch = useDispatch();

    // console.log(data)
    const [isFormResponse, setIsFormResponse] = useState(false);
    const [formResponseMessage, setFormResponseMessage] = useState("");
    const [formResponseStatus, setFormResponseStatus] = useState("");
   
   
    const [formDefaultValues, setFormDefaultValues] = useState({
        customer_id: data.customer_id,
        customer_name: data.customer_name,
        address: data.address,
        mode: data.mode,
        gstin_no: data.gstin_no,
        pan_no: data.pan_no,
        mobile_no: data.mobile_no
    });

    const [mode, setMode] = useState(data.mode);


    const [form] = Form.useForm();

    const onGeneralCustomerSave = async (values) => {
        //   console.log(values);
        const data = { formdata: values };
        // console.log(data);

        const response = generalCustomerService.save(data).then((resdata) => {

            setIsFormResponse(true);
            setFormResponseStatus(resdata.response_status);
            setFormResponseMessage(resdata.response_msg);

            const x = {
                customer_id:commonUtility.randomID()                              
            }
            dispatch(addCustomer(x))
        });
    };


    const hideResponseMessage = () => {
        setIsFormResponse(false);
        if(mode=="ADD") {
            form.resetFields();
            form.setFieldsValue({
                customer_id: formDefaultValues.customer_id,
                mode: formDefaultValues.mode,
                is_active: "Y",
            })
        }
    }
    

    useEffect(() => {

        mode == EDIT_MODE ?
            form.setFieldsValue({
                customer_id: formDefaultValues.customer_id,
                customer_name: formDefaultValues.customer_name,               
                address: formDefaultValues.address, 
                gstin_no: formDefaultValues.gstin_no,
                pan_no: formDefaultValues.pan_no,
                mobile_no: formDefaultValues.mobile_no
            })
            :
            form.setFieldsValue({
                customer_id: 0,
                customer_name:'',              
                address:'', 
                gstin_no:'',
                pan_no:'',
                mobile_no:'',
                mode: data.mode               
            });

        form.setFieldsValue(formDefaultValues)
       

    }, [form]);



    return (
        <div>
            <div className="form-input-style">

                <Row className="" style={{ background: "transparent" }}>
                    <Col className="" xs={24} xl={24}>
                        <Form
                            form={form}
                            layout="vertical"
                            onFinish={onGeneralCustomerSave}
                            autoComplete="off"
                        // initialValues={formDefaultValues}
                        >

                            {/* <Row gutter={20}>
                            <Col className="gutter-row" xs={24} xl={24}>
                                <h5>Note: * fields are required</h5>
                            </Col>
                        </Row> */}
                            <Row gutter={20}>

                            <Form.Item name="customer_id" label="customer_id" hidden={true}>
                                <Input type="text" />
                            </Form.Item>
                            <Form.Item name="mode" label="mode" hidden={true}>
                                <Input type="text" />
                            </Form.Item>

                               <Col xs={24} xl={12}>
                                    <Form.Item name="customer_name" label="Name" rules={[
                                        {
                                            required: true,
                                            message: 'Customer name is required',
                                        },
                                    ]}>
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="mobile_no" label="Mobile No." >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="gstin_no" label="GSTIN" >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>       

                                <Col xs={24} xl={12}>
                                    <Form.Item name="pan_no" label="PAN" >
                                        <Input placeholder="" />
                                    </Form.Item>
                                </Col>

                                <Col xs={24} xl={12}>
                                    <Form.Item name="address" label="Address" >
                                        <TextArea rows={2} placeholder="" />
                                    </Form.Item>
                                </Col>   
                                    

                                <Col xs={24} xl={12}>
                                    <Form.Item name="" label=" " style={{ textAlign: 'left' }}>
                                        <Space>
                                            <Button htmlType="submit"  className="custom-button-green" >
                                                Save <RightOutlined />
                                            </Button>
                                        </Space>
                                    </Form.Item>
                                </Col>

                            </Row>
                        </Form>



                    </Col>
                </Row>
                {
                    // isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} /> : ''
                    isFormResponse ? <CustomMessage title={formResponseStatus} subtitle={formResponseMessage} action={hideResponseMessage} onDrawerClose={onDrawerClose} mode={form.getFieldValue('mode')} /> : ''
                }




            </div>
        </div>
    );
};

export default GeneralCustomerEntry
